import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import { orderBy, uniqWith, isEqual, find } from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';
import UAParser from 'ua-parser-js';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import InputBase from '@material-ui/core/InputBase';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import RefreshIcon from '@material-ui/icons/Refresh';
import Popover from '@material-ui/core/Popover';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import SearchIcon from '@material-ui/icons/Search';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import Paper from '@material-ui/core/Paper';
import { makeStyles, styled } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import * as MemberService from '../../api/memberService';
import * as StoreService from '../../api/storeService';
import * as EmploymentService from '../../api/employmentService';
import * as ProfileService from '../../api/profileService';
import * as RestrictionService from '../../api/restrictionService';
import * as StampCampaignService from '../../api/stampCampaignService';
import useCompanyContext from '../../hooks/useCompanyContext';
import useDialogState from '../../hooks/useDialogState';
import useSelectedStoreContext from '../../hooks/useSelectedStoreContext';
import useAuthContext from '../../hooks/useAuthContext';
import useNavContext from '../../hooks/useNavContext';
import useNoSleep from '../../hooks/useNoSleep';
import useModeTypeContext from '../../hooks/usemodeTypeContext';
import SelectStoreDialog from '../../components/Dialog/SelectStoreDialog';
import JoiningCodeDialog from '../../components/Dialog/JoiningCodeDialog';
import NewMemberDialog from '../../components/Dialog/NewMemberDialog';
import MemberDetailsDialog from '../../components/Dialog/MemberDetailsDialog';
import AddDynamicStampDialog from '../../components/Dialog/AddDynamicStampDialog';
import DynamicQRCodeDialog from '../../components/Dialog/DynamicQRCodeDialog';
import SaveToHomeScreenDialog from '../../components/Dialog/SaveToHomeScreenDialog';
import Spinner from '../../components/Spinner';
import QRCodeModeDialog from '../../components/Dialog/QRCodeModeDialog';
// import NotFound from '../Errors/NotFound';
import QRCodeMode from '../QRCodeMode';
import KioskMode from '../KioskMode';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  grow: {
    flexGrow: 1,
  },
  nameContainer: {
    marginTop: theme.spacing(20),
    marginBottom: theme.spacing(20),
  },
  name: {
    margin: 15,
    cursor: 'pointer',
  },
  line: {
    width: '100%',
    height: 1,
    backgroundColor: '#cccccc',
  },
  initLetter: {
    marginLeft: 15,
    marginTop: 30,
    marginBottom: 15,
  },
  hide: {
    display: 'none',
  },
  bottombar: {
    top: 'auto',
    bottom: 0,
  },
  bottomToolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignContent: 'center',
    padding: 0,
  },
  memberName: {
    cursor: 'pointer',
  },
  appbar: {
    boxShadow: '0 0 20px #e4e4e4',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  topToolbar: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  refreshContainer: {
    position: 'fixed',
    right: 82,
    top: 32,
  },
  volumeContainer: {
    position: 'fixed',
    right: 50,
    top: 32,
  },
  profileContainer: {
    position: 'fixed',
    right: 18,
    top: 32,
  },
  profileAction: {
    position: 'fixed',
    right: 8,
    top: 20,
  },
  spinnerMobile: {
    marginTop: 125,
    marginBottom: 20,
  },
  spinner: {
    marginTop: 270,
    marginBottom: 20,
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingScroll: {
    marginLeft: 15,
  },
  iconButton: {
    padding: 10,
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  manager: {
    color: theme.palette.primary.main,
  },
  admin: {
    color: '#0000FF',
  },
  qrCode: {
    color: theme.palette.common.black,
  },
  user: {
    color: '#666666',
  },
  basic: {
    color: '#AE41CC',
  },
  popover: {
    padding: theme.spacing(2),
  },
  profileInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  profileInfoRow: {
    display: 'flex',
    flexDirection: 'row',
    margin: theme.spacing(),
  },
  profileInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  profileInfoLabel: {
    width: 42,
  },
  spacer: {
    width: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  profileInfoText: {
    inlineSize: '250px',
    overflowWrap: 'break-word',
  },
  noNetworkContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100vw',
  },
  noNetworkHeader: {
    marginBottom: theme.spacing(),
  },
  noNetworkSubText: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: 16,
    textAlign: 'center',
  },
  wifiOff: {
    width: 150,
    height: 150,
  },
}));

const ActionButton = styled(Button)({
  height: 80,
  width: '100%',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: '#EA0043',
    color: '#FFF',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EA0043',
    color: '#FFF',
  },
});

/**
 * Main screen
 */
export default function Main() {
  const classes = useStyles();
  const networkErrorReloadTimerRef = useRef<NodeJS.Timeout | null>(null);
  const { company } = useCompanyContext();
  const mode = useModeTypeContext();
  const selectedStore = useSelectedStoreContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [employment, setEmployment] =
    useState<EmploymentService.Employment | null>(null);
  const [profile, setProfile] = useState<ProfileService.Profile | null>(null);
  const [selectStoreDialogOpen, setSelectStoreDialogOpen] = useState(
    selectedStore && !selectedStore.selectedStore?.storeId ? true : false,
  );
  const [joinCodeOpenDialog, setJoinCodeOpenDialog] = useState(false);
  const [newMemberOpenDialog, setNewMemberOpenDialog] = useState(false);
  const [
    memberDetailsDialogOpen,
    openMemberDetailsDialog,
    closeMemberDetailsDialog,
  ] = useDialogState(false);
  const [addStampOpenDialog, setAddStampOpenDialog] = useState(false);
  const [saveToHomeDialog, setSaveToHomeDialog] = useState(false);
  const [showDynamicQRStamp, setShowDynamicQRStamp] = useState(false);
  const [qrCodeModeOpenDialog, setQRCodeModeOpenDialog] = useState(false);
  const [selectedMemberId, setSelectMemberId] = useState('');
  const [resultState, setResultState] = useState('list');
  const [memberList, setMemberList] = useState<MemberService.Member[] | null>(
    null,
  );
  const [pagination, setPagination] = useState<MemberService.Pagination | null>(
    null,
  );
  const [storeSelected, setStoreSelected] = useState<StoreService.Store | null>(
    null,
  );
  const [filteredList, setFilteredList] = useState<
    MemberService.Member[] | null
  >(null);
  const [stampNum, setStampNum] = useState(0);
  const [searchBarValue, setSearchBarValue] = useState<string>('');
  let initLetter = '';
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState<null | HTMLElement>(
    null,
  );
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [employmentFetchFailed, setEmploymentFetchFailed] = useState(false);
  const [profileFetchFailed, setProfileFetchFailed] = useState(false);
  const [maxStampIssued, setMaxStampIssued] = useState(1);
  const [stampCampaignList, setStampCampaignList] = useState<
    StampCampaignService.StampCampaign[]
  >([]);
  const isMenuOpen = Boolean(anchorEl);
  const auth = useAuthContext();
  const nav = useNavContext();
  const history = useHistory();

  useNoSleep(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await EmploymentService.get();
        if (res) {
          setEmployment(res);
          setEmploymentFetchFailed(false);
          if (res.role === 'restricted') {
            mode!.setMode({ isKioskMode: true });
          }
        }
      } catch (e) {
        console.log('Error:', e);
        setEmploymentFetchFailed(true);
      }
    };
    if (!employment) {
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await ProfileService.get();
        setProfile(res);
        setProfileFetchFailed(false);
      } catch (e) {
        console.log('Error:', e);
        setProfileFetchFailed(true);
      }
    };
    fetch();
  }, []);

  const handleRetryBootstrap = () => {
    window.location.reload();
  };

  useEffect(() => {
    const hasBootstrapError = employmentFetchFailed || profileFetchFailed;

    if (hasBootstrapError) {
      if (!networkErrorReloadTimerRef.current) {
        networkErrorReloadTimerRef.current = setTimeout(
          () => {
            window.location.reload();
          },
          2 * 60 * 1000,
        );
      }
    } else if (networkErrorReloadTimerRef.current) {
      clearTimeout(networkErrorReloadTimerRef.current);
      networkErrorReloadTimerRef.current = null;
    }

    return () => {
      if (networkErrorReloadTimerRef.current) {
        clearTimeout(networkErrorReloadTimerRef.current);
        networkErrorReloadTimerRef.current = null;
      }
    };
  }, [employmentFetchFailed, profileFetchFailed]);

  useEffect(() => {
    const fetchRestrictionList = async () => {
      if (employment) {
        try {
          const res = await RestrictionService.listEmployeeRestriction(
            employment.company.id,
            employment.id,
          );
          if (res) {
            const restrictionStampLimit = res.find(
              (x) => x.type === 'stamp_scan_limit',
            );

            if (restrictionStampLimit) {
              setMaxStampIssued(
                parseInt(restrictionStampLimit.restriction[0], 10),
              );
            } else {
              setMaxStampIssued(20);
            }
          }
        } catch (e) {
          console.log('Error:', e);
        }
      }
    };
    if (employment) {
      fetchRestrictionList();
    }
  }, [employment]);

  useEffect(() => {
    const fetch = async () => {
      if (
        company &&
        selectedStore &&
        selectedStore.selectedStore &&
        selectedStore.selectedStore.storeId
      ) {
        try {
          const store = await StoreService.get(
            company.id,
            selectedStore.selectedStore.storeId,
          );

          setStoreSelected(store);
        } catch (e) {
          console.log('Error:', e);
        }
      }
    };
    fetch();
  }, [selectedStore, company]);

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      if (
        company &&
        employment &&
        employment.role !== 'restricted' &&
        employment.role !== 'basic'
      ) {
        const res = await MemberService.list(company.id, { page: 1, per: 50 });
        const resStampCampaign = await StampCampaignService.listActive(
          company.id,
        );
        const lowercaseRes = res.members.map((r) => ({
          id: r.id,
          totalStamps: r.totalStamps,
          createdAt: r.createdAt,
          email: r.email,
          name: r.name ? r.name.toLowerCase() : 'unknown unknown',
          user: r.user,
          mobNumber: r.mobNumber,
          loyaltyProgram: r.loyaltyProgram,
        }));
        setMemberList(orderBy(lowercaseRes, 'name', 'asc'));
        setPagination(res.pagination);
        setStampCampaignList(resStampCampaign);
        setIsLoading(false);
      }
    };

    fetch();
  }, [company, employment]);

  const isMobile = useMemo(() => {
    var parser = new UAParser();
    const result = parser.getResult();
    const deviceType = result.device.type || 'desktop';

    return deviceType === 'mobile';
  }, []);

  const handleLogOut = async () => {
    handleMenuClose();

    auth?.removeSession();
    nav?.removeNav();
    selectedStore?.removeSelectedStore();
    mode?.removeMode();
    history.replace({});
    history.push(`/`);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClose = () => {
    setProfileAnchorEl(null);
    setIsProfileOpen(false);
  };

  const renderMenu = (
    <Drawer anchor="top" open={isMenuOpen} onClose={handleMenuClose}>
      <List>
        <ListItem
          button
          key="home"
          disabled={nav?.nav?.menuNav === 'home'}
          onClick={() => {
            handleMenuClose();
            history.push('/');
            nav?.setNav({
              menuNav: 'home',
            });
          }}
        >
          <ListItemText primary="HOME" />
        </ListItem>
        <ListItem
          button
          key="home"
          disabled={nav?.nav?.menuNav === 'qrcode'}
          onClick={() => {
            handleMenuClose();
            setQRCodeModeOpenDialog(true);
          }}
        >
          <ListItemText primary="QR CODE ONLY" />
        </ListItem>
        <ListItem
          button
          key="logout"
          onClick={() => {
            handleLogOut();
          }}
        >
          <ListItemText primary="LOGOUT" />
        </ListItem>
      </List>
    </Drawer>
  );

  const fetchMemberList = useCallback(async () => {
    if (company) {
      try {
        const res = await MemberService.list(company.id, { page: 1, per: 50 });
        const lowercaseRes = res.members.map((r) => ({
          id: r.id,
          totalStamps: r.totalStamps,
          createdAt: r.createdAt,
          email: r.email,
          name: r.name ? r.name.toLowerCase() : 'unknown unknown',
          user: r.user,
          mobNumber: r.mobNumber,
          loyaltyProgram: r.loyaltyProgram,
        }));
        setMemberList(orderBy(lowercaseRes, 'name', 'asc'));
        setPagination(res.pagination);
        setIsLoading(false);
      } catch (e: any) {
        console.log('Error:', e);
        setIsLoading(false);
      }
    }
  }, [company]);

  const checkMemberExist = useCallback(
    async (memberId: string) => {
      const existMember = find(memberList, function (member) {
        return member.id === memberId;
      });

      if (!existMember && company && memberList) {
        try {
          const resMember = await MemberService.getMember(company.id, memberId);
          const resUser = await MemberService.getUser(company.id, memberId);

          if (resMember && resUser) {
            const newMember = [
              {
                id: resMember.id,
                totalStamps: resMember.totalStamps,
                createdAt: resMember.createdAt,
                email: resUser.email,
                name:
                  resUser.firstName && resUser.lastName
                    ? resUser.firstName.toLowerCase() +
                      ' ' +
                      resUser.lastName.toLowerCase()
                    : 'unknown unknown',
                user: resMember.user,
                mobNumber: resUser.mobNum,
                loyaltyProgram: resMember.loyaltyProgram,
              },
            ];
            const concatList = memberList.concat(newMember);
            const updatedList = uniqWith(concatList, isEqual);
            setMemberList(orderBy(updatedList, 'name', 'asc'));
          }
        } catch (e: any) {
          console.log('Error fetching member info:', e);
        }
      }
    },
    [company, memberList],
  );

  const handleSearch = useCallback(async () => {
    if (searchBarValue.length > 0 && company) {
      setResultState('search');
      const page = 1;
      const per = 500;
      try {
        const res = await MemberService.searchList(company.id, searchBarValue, {
          page,
          per,
        });
        const lowercaseRes = res.members.map((r) => ({
          id: r.id,
          totalStamps: r.totalStamps,
          createdAt: r.createdAt,
          email: r.email,
          name: r.name ? r.name.toLowerCase() : 'unknown unknown',
          user: r.user,
          mobNumber: r.mobNumber,
          loyaltyProgram: r.loyaltyProgram,
        }));
        setFilteredList(orderBy(lowercaseRes, 'name', 'asc'));
        setPagination(res.pagination);
      } catch (e: any) {
        console.log('Error:', e);
      }
    }

    if (searchBarValue.length === 0) {
      setResultState('list');
      setIsLoading(true);
      setMemberList(null);
      fetchMemberList();
    }
  }, [searchBarValue, company, fetchMemberList]);

  const capitalizeName = (name: string) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  const loadMoreRecord = useCallback(async () => {
    const updatedPage = pagination ? pagination.page + 1 : 1;
    const per = pagination ? pagination.per : 50;

    if (company) {
      try {
        const res = await MemberService.list(company.id, {
          page: updatedPage,
          per,
        });
        const lowercaseRes = res.members.map((r) => ({
          id: r.id,
          totalStamps: r.totalStamps,
          createdAt: r.createdAt,
          email: r.email,
          name: r.name ? r.name.toLowerCase() : 'unknown unknown',
          user: r.user,
          mobNumber: r.mobNumber,
          loyaltyProgram: r.loyaltyProgram,
        }));
        if (!memberList) {
          setMemberList(orderBy(lowercaseRes, 'name', 'asc'));
        } else {
          const concatList = memberList.concat(lowercaseRes);
          const updatedList = uniqWith(concatList, isEqual);
          setMemberList(orderBy(updatedList, 'name', 'asc'));
        }

        setPagination(res.pagination);
        setIsLoading(false);
      } catch (e: any) {
        console.log('Error:', e);
        setIsLoading(false);
      }
    }
  }, [company, pagination, memberList]);

  if (employmentFetchFailed || profileFetchFailed) {
    return (
      <div className={classes.noNetworkContainer}>
        <Typography variant="h5" className={classes.noNetworkHeader}>
          Network Error
        </Typography>
        <WifiOffIcon color="disabled" className={classes.wifiOff} />
        <Typography className={classes.noNetworkSubText}>
          Please check your connection and tap REFRESH to try again.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRetryBootstrap}
        >
          REFRESH
        </Button>
      </div>
    );
  }

  if (!company) {
    return <Spinner />;
  }

  if (!employment) {
    return <Spinner />;
  }

  if (!profile) {
    return <Spinner />;
  }

  return (
    <>
      {employment.role === 'restricted' ? (
        <>
          <KioskMode />
        </>
      ) : employment.role === 'basic' ? (
        <>
          <QRCodeMode />
        </>
      ) : (
        <>
          <AppBar position="fixed" color="inherit" className={classes.appbar}>
            <Toolbar className={classes.topToolbar}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </IconButton>
              <Grid item xs={7}>
                <Typography variant="h5" noWrap={true}>
                  {company.name.toLocaleUpperCase()}
                </Typography>
              </Grid>
              {!isLoading && (
                <Box
                  className={classes.refreshContainer}
                  onClick={() => {
                    setResultState('list');
                    setIsLoading(true);
                    setMemberList(null);
                    fetchMemberList();
                  }}
                >
                  <RefreshIcon />
                </Box>
              )}
              <Box
                className={classes.volumeContainer}
                onClick={() => {
                  if (isMute) {
                    setIsMute(false);
                  } else {
                    setIsMute(true);
                  }
                }}
              >
                {!isMute ? <VolumeUpIcon /> : <VolumeOffIcon />}
              </Box>
              <Box className={classes.profileContainer}>
                <IconButton
                  className={classes.profileAction}
                  aria-label="show_profile"
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    setProfileAnchorEl(event.currentTarget);
                    setIsProfileOpen(true);
                    console.log('Clicked Profile');
                  }}
                >
                  <AccountCircleIcon
                    className={
                      employment.role === 'company_admin'
                        ? classes.admin
                        : employment.role === 'manager'
                          ? classes.manager
                          : employment.role === 'owner'
                            ? classes.admin
                            : employment.role === 'restricted'
                              ? classes.qrCode
                              : employment.role === 'companion_app'
                                ? classes.user
                                : employment.role === 'basic'
                                  ? classes.basic
                                  : classes.user
                    }
                  />
                </IconButton>
              </Box>
            </Toolbar>
            {!isLoading && (
              <Toolbar className={classes.topToolbar}>
                <Paper component="form" className={classes.root}>
                  <InputBase
                    className={classes.input}
                    placeholder="Search name, email or mobile"
                    inputProps={{ 'aria-label': 'search' }}
                    onChange={(e) => setSearchBarValue(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                      }
                    }}
                    value={searchBarValue}
                  />
                  <IconButton
                    className={classes.iconButton}
                    aria-label="search"
                    onClick={() => handleSearch()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </Toolbar>
            )}
          </AppBar>
          {renderMenu}
          <div className={classes.grow}>
            <div className={classes.container}>
              <div className={classes.nameContainer}>
                <Popover
                  open={isProfileOpen}
                  anchorEl={profileAnchorEl}
                  onClose={handleProfileClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  <Paper className={classes.popover}>
                    <div className={classes.profileInfo}>
                      <div className={classes.profileInfoRow}>
                        <Typography className={classes.profileInfoLabel}>
                          <strong>User:</strong>
                        </Typography>
                        <div className={classes.spacer} />
                        <Typography className={classes.profileInfoText}>
                          {capitalizeName(profile.firstName) +
                            ' ' +
                            capitalizeName(profile.lastName)}
                        </Typography>
                      </div>
                      {storeSelected && (
                        <div className={classes.profileInfoRow}>
                          <Typography className={classes.profileInfoLabel}>
                            <strong>Store:</strong>
                          </Typography>
                          <div className={classes.spacer} />
                          <div className={classes.profileInfoColumn}>
                            <Typography className={classes.profileInfoText}>
                              {storeSelected.name}
                            </Typography>
                            <Typography className={classes.profileInfoText}>
                              {storeSelected.address}
                            </Typography>
                          </div>
                        </div>
                      )}
                      {employment && (
                        <div className={classes.profileInfoRow}>
                          <Typography className={classes.profileInfoLabel}>
                            <strong>Role:</strong>
                          </Typography>
                          <div className={classes.spacer} />
                          <Typography className={classes.profileInfoText}>
                            {employment.role === 'company_admin'
                              ? 'Company Admin'
                              : employment.role === 'manager'
                                ? 'Manager'
                                : employment.role === 'owner'
                                  ? 'Owner'
                                  : employment.role === 'restricted'
                                    ? 'Restricted User'
                                    : employment.role === 'companion_app'
                                      ? 'General User'
                                      : employment.role === 'basic'
                                        ? 'Basic User'
                                        : ''}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Paper>
                </Popover>
                {isLoading ? (
                  <div className={classes.loading}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      className={
                        isMobile ? classes.spinnerMobile : classes.spinner
                      }
                    >
                      <Spinner />
                    </Box>
                    <Typography variant="caption">
                      Loading members... this could take a while.
                    </Typography>
                  </div>
                ) : (
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMoreRecord}
                    loader={
                      <div className={classes.loadingScroll}>
                        <Spinner />
                      </div>
                    }
                    hasMore={
                      pagination
                        ? pagination.total > pagination.page * pagination.per &&
                          resultState === 'list'
                        : false
                    }
                  >
                    {resultState === 'search' &&
                      filteredList &&
                      filteredList.length > 0 &&
                      filteredList.map((member) => (
                        <div key={member.id}>
                          {initLetter.toUpperCase() !==
                            member.name[0].toUpperCase() && (
                            <Typography
                              variant="h5"
                              key={member.id + 'A'}
                              className={classes.initLetter}
                            >
                              {member.name[0].toUpperCase()}
                            </Typography>
                          )}
                          {initLetter.toUpperCase() !==
                          member.name[0].toUpperCase() ? (
                            <div className={classes.hide} key={member.id + 'B'}>
                              {(initLetter = member.name[0].toUpperCase())}
                            </div>
                          ) : (
                            <div
                              className={classes.line}
                              key={member.id + 'B'}
                            />
                          )}
                          <div
                            key={member.id + 'C'}
                            className={classes.memberName}
                            onClick={() => {
                              setSelectMemberId(member.id);
                              openMemberDetailsDialog();
                              setSearchBarValue('');
                            }}
                          >
                            <Typography
                              variant="body1"
                              key={member.id + 'D'}
                              className={classes.name}
                            >
                              {member.name.toUpperCase() +
                                ' ' +
                                member.email +
                                ' ' +
                                member.mobNumber}
                            </Typography>
                          </div>
                        </div>
                      ))}
                    {resultState === 'search' &&
                      filteredList &&
                      filteredList.length === 0 && (
                        <div>
                          <Typography
                            variant="h5"
                            className={classes.initLetter}
                          >
                            No results
                          </Typography>
                        </div>
                      )}
                    {resultState === 'list' &&
                      memberList &&
                      memberList.map((member) => (
                        <div key={member.id}>
                          {initLetter.toUpperCase() !==
                            member.name[0].toUpperCase() && (
                            <Typography
                              variant="h5"
                              key={member.id + 'A'}
                              className={classes.initLetter}
                            >
                              {member.name[0].toUpperCase()}
                            </Typography>
                          )}
                          {initLetter.toUpperCase() !==
                          member.name[0].toUpperCase() ? (
                            <div className={classes.hide} key={member.id + 'B'}>
                              {(initLetter = member.name[0].toUpperCase())}
                            </div>
                          ) : (
                            <div
                              className={classes.line}
                              key={member.id + 'B'}
                            />
                          )}
                          <div
                            key={member.id + 'C'}
                            className={classes.memberName}
                            onClick={() => {
                              setSelectMemberId(member.id);
                              openMemberDetailsDialog();
                            }}
                          >
                            <Typography
                              variant="body1"
                              key={member.id + 'D'}
                              className={classes.name}
                            >
                              {member.name.toUpperCase()}
                            </Typography>
                          </div>
                        </div>
                      ))}
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
          <AppBar color="inherit" className={classes.bottombar}>
            <Toolbar className={classes.bottomToolbar}>
              <ActionButton
                variant="text"
                onClick={() => setNewMemberOpenDialog(true)}
              >
                +ADD MEMBER
              </ActionButton>
              <ActionButton
                variant="text"
                onClick={() => setJoinCodeOpenDialog(true)}
              >
                JOINING CODE
              </ActionButton>
              <ActionButton
                variant="text"
                onClick={() => setAddStampOpenDialog(true)}
              >
                ADD STAMP CODE
              </ActionButton>
            </Toolbar>
          </AppBar>
          <SaveToHomeScreenDialog
            open={saveToHomeDialog}
            onClose={() => setSaveToHomeDialog(false)}
          />
          <JoiningCodeDialog
            open={joinCodeOpenDialog}
            onClose={() => setJoinCodeOpenDialog(false)}
          />
          <NewMemberDialog
            open={newMemberOpenDialog}
            onClose={() => setNewMemberOpenDialog(false)}
            onSuccess={(memberId: string) => {
              setNewMemberOpenDialog(false);
              setSelectMemberId(memberId);
              checkMemberExist(memberId);
              openMemberDetailsDialog();
              setResultState('list');
            }}
          />
          <SelectStoreDialog
            employment={employment}
            profile={profile}
            open={selectStoreDialogOpen}
            onClose={() => setSelectStoreDialogOpen(false)}
            onSuccess={(store: StoreService.Store) => {
              selectedStore?.setSelectedStore({
                storeId: store.id,
                storeName: store.name,
              });
              setStoreSelected(store);
              setSaveToHomeDialog(true);
            }}
          />
          {selectedMemberId && (
            <MemberDetailsDialog
              open={memberDetailsDialogOpen}
              onClose={() => {
                closeMemberDetailsDialog();
                setSelectMemberId('');
                setResultState('list');
                setSearchBarValue('');
                setIsLoading(true);
                setMemberList(null);
                fetchMemberList();
              }}
              memberId={selectedMemberId}
              store={storeSelected}
              isVolumeMute={isMute}
              role={employment.role}
              maxSelectedNumber={maxStampIssued}
            />
          )}
          <AddDynamicStampDialog
            open={addStampOpenDialog}
            onClose={() => {
              setAddStampOpenDialog(false);
            }}
            handleConfirm={(stampNumber: number) => {
              setStampNum(stampNumber);
              setAddStampOpenDialog(false);
              setShowDynamicQRStamp(true);
            }}
            maxStampIssued={maxStampIssued}
          />
          {storeSelected && maxStampIssued && (
            <QRCodeModeDialog
              open={qrCodeModeOpenDialog}
              onClose={() => {
                setQRCodeModeOpenDialog(false);
                handleLogOut();
              }}
              stampNum={'1'}
              storeId={storeSelected.id}
              maxSelectedNumber={maxStampIssued}
              stampCampaignList={stampCampaignList}
            />
          )}
          {storeSelected &&
            stampNum !== 0 &&
            showDynamicQRStamp &&
            stampCampaignList.length > 0 && (
              <DynamicQRCodeDialog
                open={showDynamicQRStamp}
                onClose={() => {
                  setStampNum(0);
                  setShowDynamicQRStamp(false);
                }}
                stampNum={stampNum}
                storeId={storeSelected.id}
                stampCampaignList={stampCampaignList}
              />
            )}
        </>
      )}
    </>
  );
}
